export const Countries = [
    {
        value: "",
        label: "Select country",
    },
    {
        value: "USA",
        label: "United States Of America",
        cities: [
            {
                value: "NYC",
                label: "New York City",
            },
            {
                value: "LA",
                label: "Los Angeles",
            },
            {
                value: "CHI",
                label: "Chicago",
            },
            {
                value: "Other",
                label: "Other"
            }
        ]
    },
    {
        value: "UK",
        label: "United Kingdom",
        cities: [
            {
                value: "LIV",
                label: "Liverpool",
            },
            {
                value: "EDB",
                label: "Edinburgh",
            },
            {
                value: "BHM",
                label: "Birmingham",
            },
            {
                value: "Other",
                label: "Other"
            }
        ]
    },
    {
        value: "AUS",
        label: "Australia",
        cities: [
            {
                value: "PER",
                label: "Perth",
            },
            {
                value: "ADE",
            },
            {
                value: "SYD",
                label: "Sydney",
            },
            {
                value: "MEL",
                label: "Melbourne",
            },
            {
                value: "BNE",
                label: "Brisbane",
            },
            {
                value: "Other",
                label: "Other"
            }
        ]
    },
    {
        value: "RSA",
        label: "South Africa",
        cities: [
            {
                value: "CPT",
                label: "Cape Town",
            },
            {
                value: "DRB",
                label: "Durban",
            },
            {
                value: "GQB",
                label: "Gqeberha"
            },
            {
                value: "JHB",
                label: "Johannesburg"
            },
            {
                value: "PRT",
                label: "Pretoria"
            },
            {
                value: "Other",
                label: "Other"
            }
        ]
    }
];

export const Cities = [].concat(
    ...Countries.filter(country => country.cities)
        .map(country => country.cities.map(city => ({ ...city, country: country.value })))
);

